/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationgpc_name">
                    {{cvGpcNameLabel}}</label
                  >
                  <input
                    v-model="vmgpathConfigFormData.gpc_name"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationgpc_workflow_config">
                    {{cvGpcWorkflowConfigLabel}}</label
                  >
                  <textarea
                    v-model="vmgpathConfigFormData.gpc_workflow_config"
                    type="text"
                    class="form-control textarea"
                    required>
                  </textarea>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationgpc_workflow_config">
                    {{cvSubsPlanIdLabel}}</label
                  >
                   <multiselect
                      v-model="vmgpathConfigFormData.subs_plan_id"
                      :options="cleanedPlanList"
                      label="label"
                      track-by="id"
                      placeholder="Select Payment Plan"
                      class=""
                      :reduce="plan => plan.id"
                    />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationgpc_report_file">
                    {{cvGpcReportFileLabel}}</label
                  >
                  <input
                    v-model="vmgpathConfigFormData.gpc_report_file"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationgpc_pdt_id">
                    {{cvGpcPdtIdLabel}}</label
                  >
                  <input
                    v-model="vmgpathConfigFormData.gpc_pdt_id"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                   <b-spinner label="Spinning"></b-spinner>
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="gpcAdd()"
                >
                  {{ cvSubmitBtn }}
                </button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { GPathConfig } from "../../../FackApi/api/GpathConfig"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"
import { SubscriptionPlans } from "../../../FackApi/api/Subscription/subscriptionPlan"
import Multiselect from "vue-multiselect"

export default {
  name: "gpathConfigAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cvCardTitle: "Add GPaths Product Configuration",
      cvCardSubHeader: "Add GPaths Product Configuration",
      cvSubmitBtn: "Add",
      cvGpcNameLabel: "GPath Product Name",
      cvGpcWorkflowConfigLabel: "GPath Product Workflow Config",
      cvSubsPlanIdLabel: "Subscription Plan Id",
      cvGpcReportFileLabel: "GPath Product Report File (Eg. .ejs)",
      cvGpcPdtIdLabel: "GPath Product Id",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "GPath Product Config Added",
      vmgpathConfigFormData: Object.assign({}, this.initFormData()),
      planIdList: [],
      cleanedPlanList: []
    }
  },
  components: {
    Multiselect
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
    this.getPlanNames()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        "gpc_name": "",
        "gpc_workflow_config": "",
        "subs_plan_id": "",
        "gpc_report_file": "",
        "gpc_pdt_id": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmgpathConfigFormData) {
          if (!this.vmgpathConfigFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * gpcAdd
     */
    async gpcAdd () {
      // if (!this.validate()) {
      //   return false
      // }
      try {
        this.cvLoadingStatus = true
        this.vmgpathConfigFormData.subs_plan_id = this.vmgpathConfigFormData.subs_plan_id

        let gpcAddResp = await GPathConfig.gpcAdd(this, this.vmgpathConfigFormData)
        await ApiResponse.responseMessageDisplay(this, gpcAddResp)
        if (gpcAddResp && !gpcAddResp.resp_status) {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitClosegpath_configAddModal", gpcAddResp.resp_data)
        }
        this.vmgpathConfigFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at gpcAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * getPlanNames
     */
    async getPlanNames () {
      try {
        const subsPlanListResp = await SubscriptionPlans.subscriptionPlanList(this)
        if (subsPlanListResp.resp_status) {
          this.planIdList = subsPlanListResp.resp_data.data
          this.cleanedPlanList = this.planIdList.map(plan => ({
            id: plan.subs_plan_id,
            label: `${plan.subs_plan_name} (${plan.subs_plan_id})`
          }))
        }
      }
      catch (err) {
        console.error("Error in getPlanNames ", err)
      }
    }
  }
}
</script>
<style lang="css">
  textarea{
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
</style>
